<template>
  <div class="page-container">
 
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">扫块管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>blockHeightTask</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        
        <!-- <el-select v-model="isFinished" placeholder="请筛选完成状态" clearable>
          <el-option>全部</el-option>
          <el-option
            v-for="item in isFinishedOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-input placeholder="请输入币种搜索" v-model="coinType" clearable></el-input>
        <el-input placeholder="请输入高度搜索" v-model="height" clearable></el-input>
        <el-select v-model="executionStatus" placeholder="请筛选执行状态" clearable>
          <el-option>全部</el-option>
          <el-option
            v-for="item in executionStatusOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <user-list @refresh="refreshList" :height="height" :coinType="coinType" :executionStatus="executionStatus"></user-list>
      <div class="countData">
        <CountDataList></CountDataList>
      </div>
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import CountDataList from './components/countData'
import { mapState, mapActions, mapMutations } from 'vuex';
import { QUERY_TYPE, PAGINATION } from './constants';

export default {
  name: 'BlockInfo',
  components: {
    UserList,CountDataList,
  },
  data() {
    return {
      seletData:{},
      coinType: '',
      height: '',
      executionStatus: '',
      executionStatusOption:[
        { value: 0, label: '待执行' },
        { value: 1, label: '执行中' },
        { value: 2, label: '已执行' },
        { value: 3, label: '执行失败' },
        
      ]
    };
  },
  computed: {
    ...mapState('blockHeightTask', ['queryType', 'queryTypeList', 'pagination'])
  },
  methods: {
    ...mapActions('blockHeightTask', ['list','getBlockHeightTask','getCountData']),
    // ...mapMutations('blockHeightTask', ['setQueryType']),
    refreshList(data = {}) {
      this.getBlockHeightTask({
        coinType:'',
        height:'',
        executionStatus:'',
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      // this.seletData={
      //   queryType: this.queryType,
      //   queryValue: this.queryValue,
      //   userType: this.userType,
      //   userStatus: this.userStatus,
      //   mark: this.mark,
      //   ...PAGINATION
      // }
      this.getBlockHeightTask({
        coinType:this.coinType,
      height:this.height,
      executionStatus:this.executionStatus,
        ...PAGINATION
      });
    }
  },
  created() {
    // this.getBlockInfoList({
    //   isFinished:'',
    //   disposeStatusInner:'',
    //   ...PAGINATION
    // });
    this.getBlockHeightTask({
      coinType:this.coinType,
      height:this.height,
      executionStatus:this.executionStatus,
      ...PAGINATION
    })
    this.getCountData()
  }
};
</script>

<style lang="less" scoped>
  .page-actions{
    margin-bottom: 10px;
  }
  .countData{
    margin-top: 20px;
  }
</style>
